import type { IconComponent } from '@consta/icons/Icon'
import type { ButtonPropView } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import type { MouseEventHandler } from 'react'
import { forwardRef } from 'react'

import type { HeaderBlockPosition } from '../HeaderBlocks'
import { useHeaderBlockContext } from '../HeaderBlocks'

type HeaderButtonProps = {
  iconPosition?: 'left' | 'right'
  label: string
  icon: IconComponent
  view: ButtonPropView
  onlyIcon?: boolean
  onClick?: MouseEventHandler
}

export const HeaderButton = forwardRef<HTMLButtonElement, HeaderButtonProps>(function HeaderButton(
  { icon, label, view, onlyIcon, onClick, iconPosition },
  ref,
) {
  const position = useHeaderBlockContext()
  const iconWithPosition = placeIcon(icon, iconPosition ?? position)

  return (
    <Button
      ref={ref}
      size="xs"
      view={view}
      label={label}
      {...iconWithPosition}
      onlyIcon={onlyIcon}
      onClick={onClick}
    />
  )
})

const placeIcon = (icon: IconComponent, position: HeaderBlockPosition) => {
  switch (position) {
    case 'left':
    case 'center':
      return { iconLeft: icon }
    case 'right':
      return { iconRight: icon }
  }
}
